function n(n){return null==n}export{n as isNullOrUndefined};
